import update from 'immutability-helper';

import { handleActions } from 'redux-actions';

import { initialState } from './initialize-state';
import {
  LOAD_PAPERWORK_LIST,
  LOAD_PAPERWORK_LIST_SUCCESS,
  LOAD_PAPERWORK_LIST_ERROR,
} from '../type';

const packageReducer = handleActions(
  new Map([
    [
      LOAD_PAPERWORK_LIST,
      state => {
        return update(state, {
          loadingStatus: {
            paperworkListLoading: { $set: true },
          },
        });
      },
    ],
    [
      LOAD_PAPERWORK_LIST_SUCCESS,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            paperworkListLoading: { $set: false },
          },
          paperworkList: {
            $set: action.payload,
          },
        });
      },
    ],
    [
      LOAD_PAPERWORK_LIST_ERROR,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            paperworkListLoading: { $set: false },
          },
          error: { $set: action.payload },
        });
      },
    ],
  ]),
  initialState,
);
export default packageReducer;
